import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLinkedin$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLinkedin extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a560a0248d018bc3a5a94691f52668262a582707', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5640841bdd62889574434b0bd9a70e6280d3df71', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '18d48c936f2c313c88d7d08995ba26f350a1d79a', d: "M7.113 5.563c0 .863-.694 1.562-1.55 1.562s-1.55-.7-1.55-1.562S4.706 4 5.563 4c.856 0 1.55.7 1.55 1.563m.012 2.812H4v10h3.125zm4.989 0H9.009v10h3.105v-5.25c0-2.918 3.768-3.157 3.768 0v5.25H19v-6.332c0-4.925-5.576-4.745-6.886-2.321z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-linkedin", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-linkedin"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-linkedin":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLinkedin$1);
            }
            break;
    } });
}

const CosmosIconLinkedin = CosmosIconLinkedin$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLinkedin, defineCustomElement };
